
    import { Component, Mixins, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import Einstellung from '@/types/Einstellung';
    import { DetailConfig, DetailParams, GridConfig, GridFilters } from '@/types';
    import { VDetail, VGrid } from '@/types/Components';
    import GridResize from '@/mixins/GridResize';
    import GridSearch from '@/mixins/GridSearch';
    import GridEdit from '@/mixins/GridEdit';
    import { ValidationRules } from '@/store/types';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
        },
    })
    export default class Einstellungen extends Mixins(Vue, GridResize, GridSearch, GridEdit) {
        public $refs!: {
            grid: VGrid<Einstellung>,
            detail: VDetail<Einstellung>,
        };

        public gridHeightAdjustment = 270;
        public einstellung = new Einstellung();
        public detail = false;

        public rules!: ValidationRules;

        public get gridConfig(): GridConfig<Einstellung> {
            return {
                id: 'einstellungen',
                title: 'Einstellungen',
                class: Einstellung,
                remote: '/verwaltung/einstellungen',
                headers: [
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        width: 50,
                    },
                    {
                        text: 'Einstellung',
                        value: 'einstellung',
                    },
                    {
                        text: 'Wert',
                        value: 'wert',
                    },
                ],
            };
        }

        public get gridFilters(): GridFilters<Einstellung> {
            return [
                {
                    property: 'searchtext',
                    type: 'string',
                    value: this.searchText,
                    operator: null,
                },
            ];
        }

        public get detailConfig(): DetailConfig<Einstellung> {
            return {
                remote: '/verwaltung/einstellung',
                title: 'Einstellung',
                class: Einstellung,
            };
        }

        public get detailParams(): DetailParams<Einstellung> {
            return {
                einstellung: this.einstellung.einstellung,
            };
        }

        public onChangeFilter(): void {
            this.$refs.grid.load(true);
        }

        public onClickEdit(einstellung: Einstellung): void {
            this.einstellung = new Einstellung(einstellung);
            this.detail = true;
        }

        public onClickNew(): void {
            this.einstellung = new Einstellung();
            this.detail = true;
        }
    }
